import { render, staticRenderFns } from "./BaseDataBank.vue?vue&type=template&id=8972b656"
import script from "./BaseDataBank.vue?vue&type=script&lang=js"
export * from "./BaseDataBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports